import axios from 'axios';
import i18next from 'i18next';
import { toast } from 'react-toastify';


const axiosBasicInstance = axios.create({
   baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:8080/portal/api/biosense/v1' : '/portal/api/biosense/v1',
   withCredentials: true,
   timeout: 30000,
});

export const AUTH_ROUTES = {
   login: '/login',
   signup: '/sign-up',
   forgotPassword: '/forgot-password',
   reset: '/reset',
   invitation: '/invitation',
   signupOrganization: '/sign-up',
   signupOrganizationSSO: '/sign-up/organization/authentication',
   signupSuccess: '/sign-up/success',
   refreshToken: '/refreshToken',
};

const ROUTES = Object.values(AUTH_ROUTES);

let serverErrorCount = 0;
let isMaintenanceTriggered = false;

axiosBasicInstance.interceptors.response.use(
  (response) => {
    // recover nếu trước đó bị maintenance
    if (isMaintenanceTriggered) {
      isMaintenanceTriggered = false;
      window.dispatchEvent(new Event("MAINTENANCE_RECOVER"));
    }

    serverErrorCount = 0;
    return response;
  },
  async (error) => {
    const status = error?.response?.status;
    console.error("Network error or server is unreachable:", error);

    // Timeout / request bị hủy: không coi là bảo trì
    if (error.code === 'ECONNABORTED' || error.code === 'ERR_CANCELED' || axios.isCancel?.(error)) {
      return Promise.reject(error);
    }

    // 🚨 1. NETWORK ERROR (không có response: CORS, offline, server down, ...)
    // Không đẩy maintenance ngay từ 1 request — cần nhiều lỗi liên tiếp như 5xx
    if (!error.response) {
      serverErrorCount++;

      if (serverErrorCount >= 3 && !isMaintenanceTriggered) {
        isMaintenanceTriggered = true;
        window.dispatchEvent(new Event("MAINTENANCE_MODE"));
      }

      return Promise.reject(error);
    }

    // 🚨 2. SERVER ERROR (có response)
    if (status >= 500) {
      console.warn("Server error but still reachable:", status);
      
      serverErrorCount++;

      if (serverErrorCount >= 3 && !isMaintenanceTriggered) {
        isMaintenanceTriggered = true;
        window.dispatchEvent(new Event("MAINTENANCE_MODE"));
      }

      return Promise.reject(error);
    }

    // 4xx / lỗi nghiệp vụ: không tăng đếm bảo trì
    return Promise.reject(error);
  }
);

export function useAxios() {
   return axiosBasicInstance;
}

export default axiosBasicInstance;
